import PageTitle from "@/components/PageTitle";
import SideBarWrapper from "@/components/SideBarWrapper";
import { ChartArea } from "lucide-react";
import { useState } from "react";
import { Listing } from "./Listing";

const Levels = () => {

  return (
    <SideBarWrapper>
      <div className="LookUpTabs">
        <div className="content-lookups xl:p-5 p-3">
          <>
            <div>
              <div className="card mb-5 p-3">
                <PageTitle icon={ChartArea} pageTitle="Levels" />
              </div>
              <Listing />
            </div>
          </>
        </div>
      </div>
    </SideBarWrapper>
  );
};

export default Levels;
